import { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  let[appli, setAppli] = useState('')
  let[pic, setPic] = useState('')
  let[pdf, setPdf] = useState('')
  let[s, setS] = useState(true)

  let[allappli, setAllapli] = useState([])
  const data = async()=>{
    const r = await axios.get("https://multeruse.vercel.app/");
    // console.log(r.data)
    setAppli(r.data.r)
    setAllapli(r.data.all)
    
  }
  // console.log(allappli)
  useEffect(()=>{
    data()
  }, [])

  useEffect(()=>{

  },[allappli])


  const handlesubmit = async (e)=>{
    e.preventDefault()
    setS(false)
    const data = new FormData(e.target)
    const adata = {
      name:data.get("name"),
      email:data.get("email"),
      pimage:data.get("pimage"),
      rdoc:data.get("rdoc"),
    }
    // console.log(adata)
    if(adata.pimage.type==='image/jpeg' || adata.pimage.type==='image/png'){
      const pdata = new FormData()
            pdata.append('file', pic)
            pdata.append("upload_preset", "chat-app")
            pdata.append("cloud_name", "dg8wmgb7d")
      const pdfdata = new FormData()
            pdfdata.append('file', pdf)
            pdfdata.append("upload_preset", "chat-app")
            pdfdata.append("cloud_name", "dg8wmgb7d")
            const response = await axios.post('https://api.cloudinary.com/v1_1/dg8wmgb7d/image/upload', pdata);
            const responsepdf = await axios.post('https://api.cloudinary.com/v1_1/dg8wmgb7d/auto/upload', pdfdata);
            const pdfUrl = responsepdf.data.url.toString();
            const imageUrl = response.data.url.toString();
            setPic(imageUrl);
            adata.pimage = imageUrl;
            adata.rdoc = pdfUrl;
            // console.log(pdfUrl)
            // console.log(response)
             // console.log(imageUrl);
            // console.log(await data.pimage)
            // console.log("adata"+ adata)
            if(responsepdf.status === 200){
              try {
          
                const response = await axios.post('https://multeruse.vercel.app/', adata, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });
                if(response.status === 200){
                  toast.success("Applicant added successfully", {position:"top-center"})
                  setAllapli(response.data.all)
                  setS(true)
                  // console.log(response)
                }
                // console.log(response);
                // window.location.reload(false)
                // document.getElementById("ff").reset()
                
              } catch (error) {
                toast.error("something went wrong",{position:"top-center"})
                setS(true)
              }

            }
           
    }
  }
  return <>
        <ToastContainer />
        <h1 style={{"textAlign" : "center"}}>Applicant Details</h1>
        {
          s ? 
          <div style={{display:"flex"}}>
            <form className="form-control" style={{width:"70vw"}} id="ff" action="/" method="post" encType="multipart/form-data" onSubmit={handlesubmit}>
                <input className="form-control" type="text" name="name" id="" placeholder="name" required />
                <input className="form-control" type="text" name="email" id="" placeholder="email" required />
                <input className="form-control" type="date" name="dob" id="" placeholder="DOB" required />
                <input className="form-control" type="text" name="state" id="" placeholder="state" style={{'textTransform':'uppercase'}} required />
                <select name="gender" id="">
                    <option >Male</option>
                    <option >Female</option>
                </select>
                <input className="form-control" type="text" name="location" id="" placeholder="place" required />
                Image:-<input className="form-check" type="file" name="pimage" accept="image/*" id=""  required onChange={(e)=>{
                                setPic(e.target.files[0])
                            }} />
                Resume:-<input className="form-check" type="file" name="rdoc" accept="application/pdf" id="" required onChange={(e)=>{
                                setPdf(e.target.files[0])
                            }} />
                <button className="btn btn-info" type="submit">Submit</button>
            </form>


          <div>

          <table className="table table-hover bg-secondary text-white">
              <thead>
                  <tr style={{"backgroundColor": "darkred"}}>
                      <th style={{"textDecoration": "underline solid white 3px"}}>Name</th>
                      <th style={{"textDecoration": "underline solid white 3px"}}>Email</th>
                      <th style={{"textDecoration": "underline solid white 3px"}}>Applicant</th>
                      <th style={{"textDecoration": "underline solid white 3px"}}>Resume</th>
                  </tr>
              </thead>
              <tbody>
                {
                  allappli.map((appli, i)=>{
                    return <tr key={i}>
                          <td>{appli.name} </td>
                          <td>{appli.email} </td>
                          <td>
                              <img width="45px" src={appli.pimage} alt="" /> 
                          </td>
                          <td> 
                            <a href={appli.rdoc} style={{textDecoration:"none", color:"white"}} target="_blank">
                            {appli.name}'s Resume 
                            </a>
                            </td>
                      </tr>
                    
                  })
                }

              </tbody>
          </table>
      </div>
          </div>
          :
          <div>
            <h1>
              Be Patient! 
            </h1>
            <h3>
              Loading...
            </h3>

          </div>

        }
  </>;
}

export default App;
